import { createTranslations } from '@npco/utils-translations'

export const createSavingsAccountModalWrapperTranslations = createTranslations({
  title: 'Activate Zeller Savings Account',
  agreeAndActivate: 'Agree & Activate',
  cancel: 'Cancel',
})
